import { css } from '@microsoft/fast-element';

export const ThirdPartyEditStyles = css`
  :host {
    width: 249px;
  }

  .accept-btn {
    margin-top: 16px;
    float: right;
  }

  .custom-segmented-control {
    align-items: center;
  }

  .custom-segmented-item {
    width: 83px;
    height: 36px;
    padding: 2px 2px 2px 2px;
    border: 1px solid #879ba6;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    font-family: 'Roboto-Medium', 'Roboto Medium', 'Roboto', sans-serif;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.59);
    text-align: center;
    line-height: normal;
    justify-content: center;
  }

  .checked {
    background-color: #535e66;
    box-sizing: border-box;
    color: #fff;
  }

  .username-label {
    font-size: 14px;
    font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    color: #879ba6;
    text-align: left;
    line-height: normal;
    margin: 6px 0;
  }
`;
